import React from "react";
import { useNavigate } from "react-router-dom";
import { useRegistration } from "../context/RegistrationContext";
import Navbar from "../components/Navbar";
import PromoBanner from "../components/PromoBanner";
import Footer from "../components/Footer";
import { HeroSection, CoachesSection, BenefitsSection, JerseySection, SponsorSection, PricingSection, ServicesSection, FinalCtaSection, ContactSection } from "../components/landing/LandingSections";

export default function Landing() {
  const navigate = useNavigate();
  const { config } = useRegistration();
  const camp = config?.camp_info;
  const closed = config?.registration_closed;
  const toRegister = () => navigate("/register");

  return (
    <div>
      <Navbar />
      <HeroSection camp={camp} closed={closed} onRegister={toRegister} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10 relative z-10"><PromoBanner /></div>
      <CoachesSection />
      <BenefitsSection schedule={camp?.schedule} />
      <JerseySection />
      <SponsorSection packages={config?.sponsor_packages || []} onSponsor={() => navigate("/sponsor")} />
      <PricingSection categories={config?.categories} closed={closed} />
      <ServicesSection />
      <FinalCtaSection closed={closed} onRegister={toRegister} />
      <ContactSection />
      <Footer camp={config} />
    </div>
  );
}
